import { getFullDateISO } from "@sf-core";

const getUISchema = (parameters) => {
  let s = {
    type: "VerticalLayout",
    elements: [
      {
        type: "HorizontalLayout",
        elements: [
          {
            type: "Control",
            i18nKey:
              "executionFlowsScreen.newExecutionFlowScreen.executionFlowTypeId",
            scope: "#/properties/executionFlowTypeId",
          },
          {
            type: "Control",
            i18nKey: "executionFlowsScreen.newExecutionFlowScreen.comments",
            scope: "#/properties/comments",
            options: {
              multi: true,
              maxRows: 3,
            },
          },
        ],
      },
    ],
  };

  if (parameters) {
    let paramElements = [];
    Object.keys(parameters.properties).forEach((key) =>
      paramElements.push({
        type: "Control",
        label: key,
        scope: `#/properties/${key}`,
        ...(parameters.properties[key]?.format === "date" && {
          dateFormatter: (date) => getFullDateISO(date),
        }),
      })
    );

    s.elements.push({
      type: "HorizontalLayout",
      elements: paramElements,
    });
  }

  return s;
};
export default getUISchema;
